import { LOADING_BAR_DISABLE,LOADING_BAR_ENABLE } from '../actionTypes';

export const loadingBarEnable = () => (dispatch) =>
  dispatch({ type: LOADING_BAR_ENABLE });

export const loadingBarDisable = () => (dispatch) =>
  dispatch({ type: LOADING_BAR_DISABLE });
